module.exports = __webpack_public_path__ + "assets/img/17@3x.24a33d3f.png";